import { DEFAULT_REVIEW_FEATURE_CONFIG } from '../review-mode-side-panel';
import type { TaskStateT } from '../types/types';
import type { TaskModeT } from './constants';
import type { TaskStateInfoT } from './types';
import type { TaskStateStoreT } from './types';
export const getTaskStateStore = (taskState: TaskStateT): TaskStateStoreT => {
  return {
    hasRequiredTaskMode: (requiredTaskMode: TaskModeT) => taskState.taskModes.includes(requiredTaskMode),
    ...getTaskStateInfo(taskState)
  };
};
export const getTaskStateInfo = (taskState: TaskStateT): TaskStateInfoT => {
  return {
    readOnly: taskState.readOnly,
    taskModes: taskState.taskModes,
    disableActions: !!taskState.disableActions,
    reviewModeVersion: taskState.reviewModeVersion || 1,
    reviewFeatureConfig: taskState.reviewFeatureConfig || DEFAULT_REVIEW_FEATURE_CONFIG,
    reviewFeatureData: taskState.reviewFeatureData
  };
};
export const getDefaultTaskStateStore = (): TaskStateStoreT => {
  return {
    hasRequiredTaskMode: () => false,
    readOnly: false,
    taskModes: [],
    disableActions: false,
    reviewModeVersion: 1,
    reviewFeatureConfig: DEFAULT_REVIEW_FEATURE_CONFIG
  };
};